
<template>
  <div class="p-2 hover:bg-trader-blue hover: text-center w-12 h-12 justify-center flex">
    <div class="flex items-center justify-center  w-12 " @click="goBack" data-ui=go-back-icon>
      <i class="fa-solid fa-arrow-left text-black "></i>
    </div>
  </div>

</template>

<script>
import router from "@/router";

export default {
  name: "CGoBack",
  data() {
    return {
      active: 0,
    };
  },
  methods: {
    goBack() {
      router.push(`/administration/` + this.active);
    },
    updateAccordion(newId) {
      this.active = newId;
    },
  },
  created() {
    this.updateAccordion(this.$route.params.accordionIndex);
  },
  mounted() {
    this.updateAccordion(this.$route.params.accordionIndex);
  },
}

</script>